import React, { useState } from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Modal, Typography } from '@mui/material';

import { StyledLabel } from '../../components/StyledComponents';
import { connect, useDispatch } from 'react-redux';
import { LetsGoBtn } from '../../components/Buttons';
import { setIsOpenServiceOrderModal } from '../../redux/mainReducer';

import visa from '../../assets/visaIcon.png';
import master from '../../assets/mastercardIcon.png';

import './DeleteModal.css';
import ApiService from '../../helpers/apiHelper';
import { useNavigate } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: { xs: 390, sm: 650 },
  minWidth: 390,

  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function ServiceOrderModal({ isOpenModal, data, savedCards }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSaveCard, setIsSaveCard] = useState(false);
  // eslint-disable-next-line
  const [cardChoice, setCardChoice] = useState(null);
  // eslint-disable-next-line

  const makePayment = (type = 'default') => {
    const apiMake = new ApiService('posts/payments/get-signature');
    // const apiMake = new ApiService('/payments/get-signature');

    if (type === 'default') {
      console.log('!payment by saved card!');
    } else {
      const newWindow = window.open('', '_blank');
      apiMake
        .postDataQueryBody(
          { isSave: isSaveCard },
          {
            ...data
          }
        )
        .then((res) => {
          dispatch(setIsOpenServiceOrderModal({ isOpen: false, data: null }));
          const url = res?.invoiceUrl;
          if (!url || !newWindow) return;
          newWindow.location.href = url;
        })
        .catch((error) => {
          console.error(error);
          if (newWindow) {
            newWindow.close();
          }
        });
    }
  };
  console.log(cardChoice);
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(setIsOpenServiceOrderModal({ isOpen: false, data: null }));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_delete_modal"
      >
        <Box sx={style} className="bonfair_delete_modal-box">
          <CloseIcon
            className="bonfair_delete_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenServiceOrderModal({ isOpen: false, data: null }));
            }}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="deleteModal-title-text">
                {/* {translate('bonfair_service_modal')} */}
                {'Оплата'}
              </StyledLabel>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{
                display: 'flex',
                justifyContent: 'start',
                flexDirection: 'column',
                alignItems: 'start'
              }}
            >
              {savedCards.length === 0 ? (
                <Typography
                  variant="subtitle2"
                  sx={{
                    mb: 2,
                    fontSize: 16,
                    fontFamily: 'FixelText-Regular',
                    fontWeight: '400',
                    textAlign: 'center',
                    maxWidth: '100%',
                    color: '#7C7C7C'
                  }}
                >
                  {`Ви ще не маєте збережених карток, щоб оформити замовлення через безпечну оплату, натисніть кнопку оплатити. Якщо бажаєте зберегти картку для наступних покупок оберіть поле “Я хочу зберегти картку”`}
                </Typography>
              ) : (
                <>
                  <FormGroup>
                    {savedCards.map((card) => {
                      const img = card?.cardMask[0] === '4' ? visa : master;
                      return (
                        <FormControlLabel
                          sx={{ m: '5px 0' }}
                          control={
                            <Checkbox
                              checked={card?.cardMask === cardChoice}
                              onChange={(event, checked) =>
                                setCardChoice(checked ? card?.cardMask : null)
                              }
                            />
                          }
                          label={
                            <Box sx={{ display: 'flex', gap: '8px' }}>
                              <img src={img} alt={card?.cardMask} />
                              <Typography
                                sx={{
                                  color: '#7C7C7C',
                                  fontFamily: 'FixelText-Regular',
                                  fontSize: { xs: '16px', sm: '18px' },
                                  fontWeight: '500'
                                }}
                              >
                                {card?.cardMask}
                              </Typography>
                            </Box>
                          }
                        />
                      );
                    })}
                  </FormGroup>
                  <Typography
                    sx={{
                      color: '#60A5DF',
                      fontFamily: 'FixelText-Regular',
                      fontSize: { xs: '16px', sm: '18px' },
                      fontWeight: '500',
                      mt: '24px',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      dispatch(setIsOpenServiceOrderModal({ isOpen: false, data: null }));
                      navigate('ua/account-settings');
                    }}
                  >
                    Налаштування карток
                  </Typography>
                </>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                margin: '20px auto 0px',
                maxWidth: '350px',
                flexDirection: { xs: 'column' },
                gap: '10px',
                alignItems: 'center'
              }}
            >
              <LetsGoBtn
                colorScheme="blue"
                size="large"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  if (cardChoice) {
                    makePayment();
                  } else {
                    makePayment('diff');
                  }
                }}
                width={'100%'}
                style={{ textTransform: 'inherit' }}
                text="Оплатити"
              />

              {savedCards?.length > 0 && (
                <LetsGoBtn
                  colorScheme="white"
                  size="large"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    dispatch(setIsOpenServiceOrderModal({ isOpen: false, data: null }));
                  }}
                  width={'100%'}
                  style={{ textTransform: 'inherit' }}
                  text="Оплатити іншою карткою"
                />
              )}
              {((savedCards?.length === 0 && !cardChoice) ||
                (savedCards.length < 3 && !cardChoice)) && (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox checked={isSaveCard} onChange={() => setIsSaveCard(!isSaveCard)} />
                    }
                    label="Я хочу зберегти картку"
                  />
                </FormGroup>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    savedCards: state.global.savedCards
  };
};
export default connect(mapStateToProps)(ServiceOrderModal);
